import axios from '@/services/axios'

/**
 * Server-side PayPal order helpers.
 * Only Apple Pay uses these; the PayPal wallet button still creates and
 * captures its order in the browser.
 */
const createPayPalOrder = async (data: {
	amount: number
	description?: string
	currency?: string
}): Promise<string> => {
	const response = await axios.post('/payments/paypal/create-order', data)
	const orderId = response.data?.data?.id

	if (!orderId) {
		throw new Error(response.data?.message ?? 'PayPal order could not be created.')
	}

	return orderId
}

const capturePayPalOrder = async (orderId: string): Promise<string> => {
	const response = await axios.post('/payments/paypal/capture-order', { order_id: orderId })
	const captureId = response.data?.data?.capture_id

	if (!captureId) {
		throw new Error(response.data?.message ?? 'PayPal payment could not be captured.')
	}

	return captureId
}

export default { createPayPalOrder, capturePayPalOrder }
